import { createGlobalStyle } from 'styled-components';

import { INavigationTheme } from 'styles/theme/navigation';
import { ITheme } from 'styles/theme';

interface IGlobalStyles extends ITheme {
  navigation: INavigationTheme;
}

export default createGlobalStyle<{ theme: IGlobalStyles; cdnAssetPrefix: string }>`
  * {
    box-sizing: border-box;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    max-width: 100%;
    max-height: 100vh;

    font-family: 'GOATProductVariableVF', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
      Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;;
    font-size: 11.5px;
    line-height: 16px;
    font-variation-settings: 'slnt' 0;

    -webkit-font-smoothing: antialiased;

    @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
      font-size: 11.5px;
      line-height: 14px;
    }

    background: ${({ theme }) => theme.navigation.backgroundColor};
    color:  ${({ theme }) => theme.navigation.textColor};
  }

  #__next {
    position: relative;
  }

  .forceShowMobileNav {
    height: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    touch-action: none;
  }

  .forceWhiteBackground {
    background-color: #FFFFFF;
  }

  .hideOverflowX {
    overflow-x: hidden;
  }

  .defaultNotification {
    background-color: ${({ theme }) => theme.navigation.backgroundColor};
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: -75px;
    right: 0;
    left: 0;
    margin: auto;
    font-size: 9px;
    height: 20px;
    line-height: 11px;
    padding: 4px;
    width: fit-content;
    z-index: 4;

    transition: all 0.5s ease-out;

    @media (min-width: 1180px) {
      display: none;
    }
  }

  .showNotification {
    top: 75px;
    border: 1px solid rgba(0,0,0, 0.7);
  }

  em {
    font-style: normal; /* if we do not set it as normal, safari slants it too much */
    font-variation-settings: 'slnt' 10; /* need to set this to show italicized on chrome */
  }

  img {
    max-width: 100%;
    display: block;
  }

  nav li::before {
  content: none;
  }

  button {
    background-color: transparent;
    border: none;

    &:focus:not(:focus-visible) {
      outline: none;
    }

    &:active {
      outline: none;
      border: none;
    }
  }

  a {
    cursor: pointer;
    color: inherit;

    &:focus:not(:focus-visible) {
      outline: none;
    }

    &:active,
    &:hover {
      color: inherit;
      text-decoration: none;
    }
  }
`;
